var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"button-onboarding",class:{ 'button-onboarding--active': _vm.active },attrs:{"variant":"white","size":"lg","block":"","pressed":false},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }